import React, { useState, useEffect } from 'react';
// Api
import client from '../../api/client';
// Data
import { emptyDominationFormData } from '../../utils/data/FormData';
// Utils
import LoadingSpinner from '../utils/LoadingSpinner';
// Constants
import { SUBMIT_DOMINATION_FORM_API } from '../../utils/ApiRoutes';

function DominationForm() {
  const submitStates = ['waiting', 'inprogress', 'failed', 'success'];
  // const [getRecieved, setGetRecieved] = useState(false);
  // const [iphoneTest, setIphoneTest] = useState(false);
  // const [debugLines, setDebugLines] = useState([]);
  // const addDebug = (msg) => setDebugLines((prev) => [.ssssssss..prev, msg]);

  // useEffect(() => {
  //   addDebug('LINE A: useEffect triggered');

  //   const runIphoneTest = async () => {
  //     try {
  //       addDebug('LINE B: running iPhone test');
  //       const result = await client.post('/iphone-test', { test: true }, false);
  //       addDebug('LINE C: ✅ iPhone test success');
  //       setIphoneTest(true);
  //     } catch (err) {
  //       addDebug('LINE D: ❌ iPhone test failed');
  //       console.error('❌ iPhone test failed:', err);
  //     }
  //   };

  //   client
  //     .get('/test-bond', false)
  //     .then(() => {
  //       addDebug('LINE E: ✅ GET /test-bond success');
  //       setGetRecieved(true);
  //     })
  //     .catch((err) => {
  //       addDebug('LINE F: ❌ GET /test-bond failed');
  //       console.error(err);
  //     });

  //   runIphoneTest();
  // }, []);

  const [formData, setFormData] = useState(emptyDominationFormData);
  const [submitState, setSubmitState] = useState(submitStates[0]);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setSubmitState(submitStates[0]);
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName) newErrors.firstName = 'First name is required';
    if (!formData.lastName) newErrors.lastName = 'Last name is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.phoneNumber) newErrors.phoneNumber = 'Phone is required';
    if (!formData.message)
      newErrors.message = 'Why do you want to serve is required';
    if (formData.haveWeMet === 'yes' && !formData.whenWhere)
      newErrors.whenWhere = 'Please specify when and where you met.';
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // addDebug('LINE 1: Submit clicked');
    setSubmitState(submitStates[1]);
    // addDebug('LINE 2: State set to inprogress');

    const validationErrors = validateForm();
    // addDebug('LINE 3: Ran validateForm');

    if (Object.keys(validationErrors).length > 0) {
      // addDebug('LINE 4: Validation failed');
      setErrors(validationErrors);
    } else {
      // addDebug('LINE 5: Validation passed');
      client
        .post(SUBMIT_DOMINATION_FORM_API, formData, false)
        .then(() => {
          // addDebug('LINE 6: ✅ Form submitted successfully');
          setSubmitState(submitStates[3]);
          setFormData(emptyDominationFormData);
          setErrors({});
        })
        .catch((err) => {
          // addDebug('LINE 7: ❌ Submission failed');
          console.error('Unable to submit submissive application', err);
          setSubmitState(submitStates[2]);
        });
    }
  };

  return (
    <form onSubmit={handleSubmit} className='grid gap-y-4 lg:gap-y-6'>
      <section className='lg:grid lg:grid-cols-2 gap-4'>
        <div>
          <label
            className='block text-gray-700 text-sm font-bold'
            htmlFor='firstName'
          >
            First Name <span className='text-error-red'>*</span>
          </label>
          <input
            type='text'
            id='firstName'
            name='firstName'
            value={formData.firstName}
            onChange={handleChange}
            autoComplete='off'
            autoFocus='off'
            className={`shadow appearance-none border bg-gray-100 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
              errors.firstName ? 'border-error-red' : ''
            }`}
            required
            aria-required='true'
            aria-invalid={errors.firstName ? 'true' : 'false'}
            aria-describedby='firstNameError'
          />
          {errors.firstName && (
            <p id='firstNameError' className='text-error-red text-xs italic'>
              {errors.firstName}
            </p>
          )}
        </div>
        <div>
          <label
            className='block text-gray-700 text-sm font-bold'
            htmlFor='lastName'
          >
            Last Name
          </label>
          <input
            type='text'
            id='lastName'
            name='lastName'
            value={formData.lastName}
            onChange={handleChange}
            autoComplete='off'
            className={`shadow appearance-none border bg-gray-100 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
              errors.lastName ? 'border-error-red' : ''
            }`}
            required
            aria-required='true'
            aria-invalid={errors.lastName ? 'true' : 'false'}
            aria-describedby='lastNameError'
          />
          {errors.lastName && (
            <p id='lastNameError' className='text-error-red text-xs italic'>
              {errors.lastName}
            </p>
          )}
        </div>
      </section>

      <div>
        <label
          className='block text-gray-700 text-sm font-bold'
          htmlFor='email'
        >
          Email <span className='text-error-red'>*</span>
        </label>
        <input
          type='email'
          id='email'
          name='email'
          value={formData.email}
          onChange={handleChange}
          autoComplete='off'
          className={`shadow appearance-none border bg-gray-100 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
            errors.email ? 'border-error-red' : ''
          }`}
          required
          aria-required='true'
          aria-invalid={errors.email ? 'true' : 'false'}
          aria-describedby='emailError'
        />
        {errors.email && (
          <p id='emailError' className='text-error-red text-xs italic'>
            {errors.email}
          </p>
        )}
      </div>

      <div>
        <label
          className='block text-sm font-bold text-gray-700'
          htmlFor={'phoneNumber'}
        >
          Phone Number
        </label>
        <input
          type='text'
          id='phoneNumber'
          name='phoneNumber'
          autoComplete='off'
          value={formData.phoneNumber}
          onChange={handleChange}
          className='shadow border rounded w-full bg-gray-100 py-2 px-3'
        />
      </div>

      <section className='lg:grid lg:grid-cols-2 gap-4'>
        <div>
          <label
            className='block text-gray-700 text-sm font-bold'
            htmlFor='experienceLevel'
          >
            Experience Level
          </label>
          <input
            type='text'
            id='experienceLevel'
            name='experienceLevel'
            autoComplete='off'
            value={formData.experienceLevel}
            onChange={handleChange}
            className='shadow appearance-none border bg-gray-100 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
          />
        </div>
        <div>
          <label
            className='block text-gray-700 text-sm font-bold'
            htmlFor='sessionInterests'
          >
            Session Interests (e.g., bondage, chastity, roleplay)
          </label>
          <input
            type='text'
            id='sessionInterests'
            name='sessionInterests'
            autoComplete='off'
            value={formData.sessionInterests}
            onChange={handleChange}
            className='shadow appearance-none border bg-gray-100 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
          />
        </div>
      </section>

      <section className='lg:grid lg:grid-cols-2 gap-4'>
        <div>
          <label
            className='block text-gray-700 text-sm font-bold'
            htmlFor='hardLimits'
          >
            Hard Limits
          </label>
          <input
            type='text'
            id='hardLimits'
            name='hardLimits'
            autoComplete='off'
            value={formData.hardLimits}
            onChange={handleChange}
            className='shadow appearance-none border bg-gray-100 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
          />
        </div>
        <div>
          <label
            className='block text-gray-700 text-sm font-bold'
            htmlFor='location'
          >
            Location (optional)
          </label>
          <input
            type='text'
            id='location'
            autoComplete='off'
            name='location'
            value={formData.location}
            onChange={handleChange}
            className='shadow appearance-none border rounded bg-gray-100 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
          />
        </div>
      </section>

      <section className='lg:grid lg:grid-cols-2 gap-4'>
        <div>
          <label
            className='block text-gray-700 text-sm font-bold'
            htmlFor='haveWeMet'
          >
            Have we met before or had a session before?
          </label>
          <select
            id='haveWeMet'
            autoComplete='off'
            name='haveWeMet'
            value={formData.haveWeMet}
            onChange={handleChange}
            className='shadow appearance-none border bg-gray-100 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
          >
            <option value=''>Select an option</option>
            <option value='yes'>Yes</option>
            <option value='no'>No</option>
          </select>
        </div>
        <div>
          <label
            className='block text-gray-700 text-sm font-bold'
            htmlFor='whenWhere'
          >
            If so, when and where?
          </label>
          <input
            type='text'
            id='whenWhere'
            autoComplete='off'
            name='whenWhere'
            value={formData.whenWhere}
            onChange={handleChange}
            className={`shadow appearance-none border bg-gray-100 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
              errors.whenWhere ? 'border-error-red' : ''
            }`}
            placeholder='E.g., June 2023 in London'
            aria-invalid={errors.whenWhere ? 'true' : 'false'}
            aria-describedby='whenWhereError'
          />
          {errors.whenWhere && (
            <p id='whenWhereError' className='text-error-red text-xs italic'>
              {errors.whenWhere}
            </p>
          )}
        </div>
      </section>

      <div className='mb-6'>
        <label
          className='block text-gray-700 text-sm font-bold'
          htmlFor='message'
        >
          Why do you want to serve? <span className='text-error-red'>*</span>
        </label>
        <textarea
          id='message'
          name='message'
          value={formData.message}
          rows={6}
          onChange={handleChange}
          autoComplete='off'
          className={`shadow appearance-none border rounded w-full py-2 px-3 bg-gray-100 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
            errors.message ? 'border-error-red' : ''
          }`}
          required
          aria-required='true'
          aria-invalid={errors.message ? 'true' : 'false'}
          aria-describedby='messageError'
        />
        {errors.message && (
          <p id='messageError' className='text-error-red text-xs italic'>
            {errors.message}
          </p>
        )}
      </div>

      {/* {getRecieved && <p>RECIEVED GET REQUEST</p>}
      {iphoneTest && <p>IPHONE TEST PASSED</p>}
      <div className='mt-6 p-4 bg-gray-100 text-xs rounded'>
        <p className='font-bold mb-2'>Debug Output:</p>
        <ul className='list-disc pl-5'>
          {debugLines.map((line, index) => (
            <li key={index}>{line}</li>
          ))}
        </ul>
      </div> */}

      <div className='grid items-center'>
        <button
          type='submit'
          className='w-full bg-colour6 hover:brightness-95 uppercase text-white py-2 rounded transition'
          aria-label='Submit submissive application'
          disabled={submitState === submitStates[1]}
        >
          {submitState === submitStates[1] ? (
            <div className='flex justify-center mx-auto'>
              <LoadingSpinner sm={true} />
            </div>
          ) : (
            <span>Make Contact</span>
          )}
        </button>
      </div>

      {submitState === submitStates[2] && (
        <div
          role='alert'
          aria-live='assertive'
          className='text-error-red mt-3 text-center'
        >
          Unable to submit the form. Please try again.
        </div>
      )}
      {submitState === submitStates[3] && (
        <div
          role='alert'
          aria-live='polite'
          className='text-green-500 mt-3 text-center'
        >
          Application submitted successfully!
        </div>
      )}
    </form>
  );
}

export default DominationForm;
